export default __webpack_public_path__ + "static/5-70b7edf605c05863f3559a0041b4d39d.png";